// extracted by mini-css-extract-plugin
export var errorsContainer = "_u2-1";
export var link = "_u2-0";